import luhnAlgorithm from '../../validators/luhn-algorithm';
import validateExpirationDate from '../../validators/date-validator';
import get from 'lodash/get';

import { CARD_NUMBER_REGXP, ZIP_CODE_REGXP, CANADA_ZIP_CODE_REGXP, PHONE_REGXP } from '../../../constants/patterns';

export default function preSubmitCreditCard(formData) {
  const errors = [];

  // switch (paymentTypeToCreditCardType(formData.cardType)) {
  //   case 'VISA':
  //   case 'MC':
  //   case 'AMEX':
  //   case 'DISCOVER_NETWORK':
  //   case 'DINERS':
  //     break;
  //   default:
  //     errors.push({
  //       field: 'creditCardType',
  //       // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
  //       errorKey: 'UNSUPPORTED_CREDIT_BRAND',
  //       currentValue: formData.cardType,
  //     });
  // }

  switch (formData.countryAbbreviation) {
    case 'US':
      if (formData.zipCode.length < 5 || !ZIP_CODE_REGXP.test(formData.zipCode)) {
        errors.push({
          field: 'zipCode',
          // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
          errorKey: 'payment.errors.INVALID_POSTAL_CODE',
          currentValue: formData.zipCode,
        });
      }

      break;
    case 'CA':
      if (formData.zipCode.length < 5 || !CANADA_ZIP_CODE_REGXP.test(formData.zipCode)) {
        errors.push({
          field: 'zipCode',
          // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
          errorKey: 'payment.errors.INVALID_POSTAL_CODE',
          currentValue: formData.zipCode,
        });
      }

      break;
    default:
      errors.push({
        field: 'countryAbbreviation',
        // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
        errorKey: 'payment.errors.INVALID_COUNTRY_CODE',
        currentValue: formData.countryAbbreviation,
      });
  }

  if (
    !formData.paymentOption &&
    (!CARD_NUMBER_REGXP.test(formData.cardNumber) || !luhnAlgorithm(formData.cardNumber))
  ) {
    errors.push({
      field: 'cardNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_NUMBER',
      currentValue: formData.cardNumber,
    });
  }

  if (formData.refundCardBrands && formData.refundCardBrands.indexOf(formData.cardType) === -1) {
    errors.push({
      field: 'cardType',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.UNSUPPORTED_CREDIT_BRAND',
      relatedFields: [ 'cardNumber' ],
      currentValue: formData.cardType,
    });
  }

  if (formData.firstName.length < 1) {
    errors.push({
      field: 'firstName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ADDRESS_FIRSTNAME',
      currentValue: formData.firstName,
    });
  }

  if (formData.lastName.length < 1) {
    errors.push({
      field: 'lastName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ADDRESS_LASTNAME',
      currentValue: formData.lastName,
    });
  }

  if (formData.phone.length < 5 || !PHONE_REGXP.test(formData.phone)) {
    errors.push({
      field: 'phone',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_PHONE',
      currentValue: formData.phone,
    });
  }

  if (formData.city.length < 1) {
    errors.push({
      field: 'city',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CITY',
      currentValue: formData.city,
    });
  }

  if (formData.address1.length < 1) {
    errors.push({
      field: 'address1',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ADDRESS_LINE1',
      currentValue: formData.address1,
    });
  }

  if (formData.expirationYear === 'YY') {
    errors.push({
      field: 'expirationYear',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_EXPIRATION_YEAR',
      currentValue: formData.expirationYear,
    });
  }

  if (formData.expirationMonth === 'MM') {
    errors.push({
      field: 'expirationMonth',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_EXPIRATION_MONTH',
      currentValue: formData.expirationMonth,
    });
  }

  const eventDate = get(formData, 'eventDate', false);

  if (eventDate && formData.expirationYear !== 'YY' && formData.expirationMonth !== 'MM') {
    const error = validateExpirationDate(eventDate, formData.expirationMonth, formData.expirationYear);

    if (error) {
      errors.push(error);
    }
  }

  return errors;
}
